// extracted by mini-css-extract-plugin
export default {"container":"FullViewSpinnerWrapper_container__E3aQw"};